import React from 'react';
import clsx from 'clsx';

import Container from '@common/Container';
import Section from '@common/Section';
import RichText from '@common/RichText';

import Video from '@common/blocks/flex/Video';
import Buttons from '@common/blocks/flex/Buttons';
import Img from '@common/Image';
import Links from '@common/blocks/flex/Links';
import MobileLinks from '@common/blocks/flex/MobileLinks';

import * as styles from '@common/blocks/flex/flex.module.scss';

const FlexBlock = ({ data }) => {
  const {
    title,
    showTitle,
    showBorder,
    text,
    textAlignment,
    textFontSize,
    textFontFamily,
    textColWidth,
    listClass,
    imagePosition,
    imagePositionTop,
    imagePositionTopLg,
    imageNegativeMargin,
    buttons,
    images,
    links,
    video,
    topMargin,
    bottomMargin,
    bgColour,
    bgPadding,
    bgFullwidth
  } = data;
  return (
    <Section style={{ marginTop: `calc(${imageNegativeMargin} + 50px)` }} spacing={clsx(topMargin, bottomMargin ? bottomMargin : 'mb-7')} className={clsx({
        [`bg-${bgColour}`]: bgColour,
        [bgPadding]: bgColour,
        ['container']: !bgFullwidth,
        [styles.removeTopMargin]: imageNegativeMargin && !imagePositionTop
      })}>
      <Container>
        {video &&
          <Video data={data}/>
        }
        <div className={clsx(`d-flex flex-column align-items-center postion-relative`, {
            'flex-md-row-reverse': imagePosition === 'Left' && !imagePositionTopLg,
            'flex-md-row': imagePosition === 'Right' && !imagePositionTopLg,
            'flex-column-reverse': imagePositionTop || imagePositionTopLg,
            'border border-dark-grey-4 border-3 rounded-3 px-3 py-3 py-lg-5': showBorder
          })}>
          {(text || buttons) &&
            <div className={clsx('col', textColWidth, {
                'mb-lg-n5': buttons,
                'text-center': textAlignment === 'Center',
                'text-end': textAlignment === 'Right',
                'text-start': textAlignment === 'Left',
              })}>
              {(showTitle && title) &&
                <div className='d-flex justify-content-center'>
                  <p style={{background: 'rgba(0, 204, 204, 0.20)'}} className='text-uppercase fs-16 fw-medium border border-2 border-teal rounded px-1'>{title}</p>
                </div>  
              }
              {text &&
                <RichText
                  json={text}
                  h1='mb-3'
                  h2='mb-3'
                  p={clsx('mb-3', textFontSize, textFontFamily)}
                  a='fs-16'
                  ul={listClass}
                />
              }
              {buttons && 
                <Buttons data={data} />
              }
            </div>
          }
          {links &&
            <Links data={data} />
          }
          {images &&
            <div className='position-relative'>
              <Img
                loading='eager'
                image={images[0]?.gatsbyImageData}
                file={images[0]?.file}
                alt={images[0]?.description}
                style={{ zIndex: -1 }}
                imgStyle={{ width: '100%', zIndex: -1 }}
              />
              <div style={{position: 'absolute', zIndex: -1, inset: 0, top: -1, bottom: '60%', background: 'linear-gradient(180deg, #FFF 0%, rgba(255, 255, 255, 0.00) 100%)'}} />
            </div>
          }
        </div>
        {links &&
          <MobileLinks data={data} />
        }
      </Container>
    </Section>
  )
}

export default FlexBlock
